'use client';

import React from 'react';
import { Content } from '@prismicio/client';
import { SliceComponentProps } from '@prismicio/react';
import styles from './step-cards.module.scss';
import { Button } from '@get-mosh/msh-shared';
import { trackClick } from 'src/analytics/Events';
import EventNames from 'src/analytics/EventNames';
import classNames from 'classnames';
import { Vertical } from 'src/constants/Verticals';
import { PrismicNextImage } from '@prismicio/next';

export type StepCardsProps = SliceComponentProps<Content.StepCardsSlice>;

const StepCards = ({
    slice,
    context,
}: StepCardsProps & {
    context: { pageType: string };
}) => {
    return (
        <section className="container mx-auto flex flex-col space-y-8 py-8 lg:py-16 xl:max-w-screen-xl">
            {slice?.primary?.title && (
                <h2 className={classNames(styles['title'], 'text-center')}>
                    {slice.primary.title}
                </h2>
            )}
            <div
                className={classNames(
                    styles['items'],
                    styles[`items-count-${slice?.items?.length}`],
                )}
            >
                {slice?.items?.length > 0 &&
                    slice.items.map((item, i) => (
                        <div key={i} className={styles['item']}>
                            {item?.image?.url ? (
                                <picture
                                    className={styles['item-image-wrapper']}
                                >
                                    <PrismicNextImage field={item.image} />
                                </picture>
                            ) : (
                                <div
                                    className={styles['item-image-placeholder']}
                                />
                            )}
                            <h5 className="rounded-lg bg-black px-3 py-2 text-white">
                                {`Step ${i + 1}`}
                            </h5>
                            <div className={styles['item-content']}>
                                <h4>{item.title}</h4>
                                <p>{item.description}</p>
                            </div>
                            {!!item.link_label && !!item.link_path && (
                                <div className={styles['item-footer']}>
                                    <Button
                                        className={styles['item-cta']}
                                        text={item.link_label}
                                        as="a"
                                        href={item.link_path}
                                        onClick={() => {
                                            trackClick(
                                                EventNames.BUTTON_CLICKED,
                                                {
                                                    pageType: context.pageType,
                                                    vertical: slice.primary
                                                        .vertical as Vertical,
                                                    label: item.link_label as string,
                                                    link: item.link_path as string,
                                                    variation: slice.variation,
                                                    location: slice.slice_type,
                                                },
                                            );
                                        }}
                                    />
                                </div>
                            )}
                        </div>
                    ))}
            </div>
            {slice?.primary?.foot_note && (
                <p className="text-center text-xs text-grey-400">
                    {slice.primary.foot_note}
                </p>
            )}
        </section>
    );
};

export default StepCards;
